export default __webpack_public_path__ + "static/media/mochi2.b56e6394.jpg";